<script setup>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Hero from "@/components/Hero.vue";
import GetStarted from "@/components/GetStarted.vue";
import Footer from "@/components/Footer.vue";

import {post} from "../mixins/http_handler";
import {ref, onMounted, onBeforeMount} from "vue";

const metaTags = ref([]);
const metaScripts = ref([]);
const metaNoScripts = ref([]);
const metaLinks = ref([]);

const isMobile = ref(false);

import {useMeta} from "vue-meta";

const getMetaInfo = () => {
  let href = process.env.VUE_APP_META_TAG_URL;
  post("/", {
    query:
        `{metaTags(url:"` +
        href +
        `")
        {website_seo_tracking_tags_id
            page_name
            page_section
            tracking_type
            tracking_comment
            tracking_sequence
            tracking_value
          }}`
  })
      .then((response) => {
        const metaTagsApi = response.data.data.metaTags;
        console.log('getMetaInfo', metaTagsApi)
        /* Metas */
        metaTagsApi
            .filter(function (metaTag) {
              return (
                  metaTag.tracking_type == "meta" &&
                  (metaTag.page_name == "all" || metaTag.page_name == "main")
              );
            })
            .forEach(metaTag => {
              metaTags.value.push(...JSON.parse(metaTag.tracking_value));
            });
        /* Scripts */
        metaTagsApi
            .filter(function (metaTag) {
              return (
                  metaTag.tracking_type == "script" &&
                  (metaTag.page_name == "all" || metaTag.page_name == "main")
              );
            })
            .forEach(metaTag => {
              metaScripts.value.push(...JSON.parse(metaTag.tracking_value));
            });
        /* No Scripts */
        metaTagsApi
            .filter(function (metaTag) {
              return (
                  metaTag.tracking_type == "noscript" &&
                  (metaTag.page_name == "all" || metaTag.page_name == "main")
              );
            })
            .forEach(metaTag => {
              metaNoScripts.value.push(...JSON.parse(metaTag.tracking_value));
            });
        /* Links */
        metaTagsApi
            .filter(function (metaTag) {
              return (
                  metaTag.tracking_type == "link" &&
                  (metaTag.page_name == "all" || metaTag.page_name == "main")
              );
            })
            .forEach(metaTag => {
              metaLinks.value.push(...JSON.parse(metaTag.tracking_value));
            });
      })
      .catch((err) => {
         console.log('getMetaInfo error', err);
      });
};

const checkIsMobile = () => {
  let width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
  isMobile.value = width < 640 ? true : false;
};

onBeforeMount(() => {
  window.addEventListener("resize", checkIsMobile);
});

onMounted(() => {
  checkIsMobile();
  getMetaInfo();
});

useMeta({
  title: "Groupon Landing Page - iLoveKickboxing",
  meta: metaTags.value,
  script: metaScripts.value,
  noscript: metaNoScripts.value,
  link: metaLinks.value
});

</script>

<template>
  <metainfo>
    <template v-slot:title="{ content }">{{ content }}</template>
  </metainfo>
  <div class="home-wrapper">
    <Header/>
    <Hero/>
    <GetStarted/>
    <Footer/>
  </div>
</template>
